module.exports = __webpack_public_path__ + "img/icon_004.cae6a12.webp";